(() => {
    if (!document.querySelector(".btn-theme-toggle")) {
        return;
    }

    const STORAGE_KEY = "site-theme";
    let pickerTimer;

    function getSavedTheme() {
        try {
            const saved = localStorage.getItem(STORAGE_KEY);
            if (saved === "light" || saved === "dark") {
                return saved;
            }
        } catch (error) {
            return null;
        }

        return null;
    }

    function applyTheme(theme) {
        document.documentElement.setAttribute("data-theme", theme);
        document.documentElement.style.colorScheme = theme;

        document.querySelectorAll(".btn-theme-toggle").forEach((button) => {
            const nextLabel = theme === "dark" ? "Ativar tema claro" : "Ativar tema escuro";
            button.setAttribute("aria-label", nextLabel);
            button.setAttribute("title", nextLabel);
        });
    }

    function persistTheme(theme) {
        applyTheme(theme);

        try {
            localStorage.setItem(STORAGE_KEY, theme);
        } catch (error) {
            /* ignore storage errors */
        }

        document.dispatchEvent(new CustomEvent("site-theme-change", { detail: { theme } }));
    }

    function toggleTheme() {
        const current = document.documentElement.getAttribute("data-theme") === "dark" ? "dark" : "light";
        persistTheme(current === "dark" ? "light" : "dark");
    }

    function closeThemePicker(picker) {
        window.clearTimeout(pickerTimer);
        picker.setAttribute("hidden", "");
        document.documentElement.classList.remove("is-theme-picker-open");
    }

    function positionThemePicker(picker, anchor) {
        const toggle = anchor || document.querySelector(".btn-theme-toggle");
        if (!toggle) {
            return;
        }

        const card = picker.querySelector(".site-theme-picker-card");
        if (!card) {
            return;
        }

        const gutter = 12;
        const gap = 10;
        const toggleRect = toggle.getBoundingClientRect();
        const cardRect = card.getBoundingClientRect();
        const maxTop = window.innerHeight - cardRect.height - gutter;
        const top = Math.max(gutter, Math.min(toggleRect.bottom + gap, maxTop));
        let left = toggleRect.left + (toggleRect.width / 2) - (cardRect.width / 2);
        left = Math.max(gutter, Math.min(left, window.innerWidth - cardRect.width - gutter));

        const arrowLeft = toggleRect.left + (toggleRect.width / 2) - left;
        const clampedArrow = Math.max(18, Math.min(arrowLeft, cardRect.width - 18));

        picker.style.setProperty("--site-theme-picker-top", `${top}px`);
        picker.style.setProperty("--site-theme-picker-left", `${left}px`);
        picker.style.setProperty("--site-theme-picker-arrow-left", `${clampedArrow}px`);
    }

    function showThemePicker(anchor) {
        let picker = document.querySelector(".site-theme-picker");
        if (!picker) {
            picker = document.createElement("div");
            picker.className = "site-theme-picker";
            picker.setAttribute("role", "dialog");
            picker.setAttribute("aria-labelledby", "site-theme-picker-title");
            picker.innerHTML = `
                <div class="site-theme-picker-card">
                    <button type="button" class="site-theme-picker-close" aria-label="Fechar sugestão de tema"></button>
                    <h2 id="site-theme-picker-title">Preferência de tema</h2>
                    <p>Por acessibilidade e conforto visual, escolha o contraste que funciona melhor para você. Você pode trocar depois pelo ícone do header.</p>
                    <div class="site-theme-picker-actions">
                        <button type="button" class="site-theme-picker-btn" data-theme-choice="dark">
                            <strong>Escuro</strong>
                        </button>
                        <button type="button" class="site-theme-picker-btn" data-theme-choice="light">
                            <strong>Claro</strong>
                        </button>
                    </div>
                </div>
            `;

            picker.addEventListener("click", (event) => {
                const choice = event.target.closest("[data-theme-choice]");
                if (choice) {
                    persistTheme(choice.getAttribute("data-theme-choice") === "light" ? "light" : "dark");
                    closeThemePicker(picker);
                    return;
                }

                closeThemePicker(picker);
            });

            document.addEventListener("click", (event) => {
                if (picker.hasAttribute("hidden")) {
                    return;
                }
                closeThemePicker(picker);
            });

            document.addEventListener("keydown", (event) => {
                if (event.key === "Escape" && !picker.hasAttribute("hidden")) {
                    closeThemePicker(picker);
                }
            });

            document.body.appendChild(picker);
        }

        document.documentElement.classList.add("is-theme-picker-open");
        // Invisível até ser posicionado: reposicionar um elemento já visível contava como deslocamento de layout (CLS)
        picker.style.visibility = "hidden";
        picker.removeAttribute("hidden");
        window.requestAnimationFrame(() => {
            window.requestAnimationFrame(() => {
                positionThemePicker(picker, anchor);
                picker.style.visibility = "";
            });
        });
        // Non-modal suggestion: do not steal focus, lock scrolling or intercept page clicks.
        window.clearTimeout(pickerTimer);
        pickerTimer = window.setTimeout(() => closeThemePicker(picker), 2000);
    }

    const savedTheme = getSavedTheme();
    applyTheme(savedTheme || (document.documentElement.getAttribute("data-theme") === "light" ? "light" : "dark"));

    if (!savedTheme) {
        window.requestAnimationFrame(() => {
            showThemePicker(document.querySelector(".btn-theme-toggle"));
        });
    }

    document.addEventListener("click", (event) => {
        const button = event.target.closest(".btn-theme-toggle");
        if (!button) {
            return;
        }
        event.preventDefault();
        toggleTheme();
    });

    window.addEventListener("resize", () => {
        const picker = document.querySelector(".site-theme-picker:not([hidden])");
        if (picker) {
            positionThemePicker(picker);
        }
    });
})();
